import { useMutation } from '@tanstack/react-query'
import { authApi } from '../../utils/api'
import { useAuth } from '../../contexts/AuthContext'

export interface DeleteAccountInput {
  reason?: string
  feedback?: string
}

/**
 * アカウント削除（退会）。
 * deleteAccount 自体が access_token を除去する。遷移（navigate('/')）は呼び出し側で行う。
 *
 * 成功時は強制ログアウトする。access_token の除去だけでは Supabase セッション
 * （localStorage の sb-* トークン）と AuthContext.user が残り、削除済みアカウントのまま
 * ルートガードを通過してログイン後の画面が見えてしまう。リロードして /auth/me が 401 を
 * 返すまで解消しないため、退会の時点で未ログイン状態へ落とす。
 */
export function useDeleteAccount() {
  const { logout } = useAuth()
  return useMutation({
    mutationFn: ({ reason, feedback }: DeleteAccountInput) =>
      authApi.deleteAccount(reason, feedback),
    onSuccess: () => logout(),
  })
}
